import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { Trans } from 'react-i18next';
import { t } from '../../../../i18n';
import {
    buildDriverConflictInterpolation,
    buildDriverConflictLocationRows,
    DriverConflictDetails,
    resolveConflictMessageI18nKey,
} from 'utils/driverConflictMessage';

export interface DriverConflict {
    messageKey: string;
    details?: DriverConflictDetails | null;
}

interface DriverConflictModalProps {
    conflict: DriverConflict | null;
    onClose: () => void;
}

/**
 * 派件司机手机号 / 证件号唯一性冲突弹窗，提交失败与表单失焦校验共用，样式与本页强校验弹窗一致
 */
const DriverConflictModal: React.FC<DriverConflictModalProps> = ({ conflict, onClose }) => {
    const tipKey = `${conflict?.messageKey}.tip`;
    const tip = conflict ? t(tipKey) : tipKey;
    const locationRows = buildDriverConflictLocationRows(conflict?.details);
    return (
        <Modal
            open={!!conflict}
            title={
                <span className="flex items-center">
                    <ExclamationCircleFilled className="text-[#faad14] text-xl mr-3" />
                    {t('errors.business.account.deliveryDriver.conflictTitle')}
                </span>
            }
            okText={t('components.button.confirm')}
            onOk={onClose}
            onCancel={onClose}
            cancelButtonProps={{ style: { display: 'none' } }}
        >
            {conflict && (
                <div>
                    <p>
                        <Trans
                            i18nKey={resolveConflictMessageI18nKey(conflict.messageKey, conflict.details)}
                            values={{ ...conflict.details, ...buildDriverConflictInterpolation(conflict.details) }}
                            components={{ b: <strong /> }}
                        />
                    </p>
                    {locationRows.length > 0 && (
                        <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 mt-3 px-4 py-3 rounded-lg border border-gray-200 bg-gray-50">
                            {locationRows.map(row => (
                                <React.Fragment key={row.labelKey}>
                                    <span className="text-gray-500">{t(row.labelKey)}</span>
                                    <span className={row.emphasis ? 'font-semibold' : undefined}>{row.value}</span>
                                </React.Fragment>
                            ))}
                        </div>
                    )}
                    {tip !== tipKey && <p className="mt-3 text-gray-500">{tip}</p>}
                </div>
            )}
        </Modal>
    );
};

export default DriverConflictModal;
